import { useEffect, useState } from 'react'

import { AppSelect } from '../../../../components/Select'
import { SelectData, SelectOptionString } from '../../../common/filter/models'
import { getCloseReasons } from '../api'

export const selectType = 'closeReason'

/**
 * Фильтр по причине закрытия депозита (CPAYMENT-1863).
 *
 * Словарь грузится с бэкенда, а не прописан здесь: причины объявляет enum, и захардкоженный
 * список молча перестал бы находить заявки с причиной, появившейся после релиза фронта.
 *
 * Фильтр самостоятельный — со статусом («Исход») он не связан: причина сама сужает выборку до
 * своих статусов, поэтому ни гасить его, ни проставлять статус за оператора не нужно.
 */
const ReportCloseReasonFilter = ({
  changeSelect,
  value,
}: {
  changeSelect: (selectData: SelectData) => void
  value: string[]
}) => {
  const [options, setOptions] = useState<Array<SelectOptionString>>([])

  useEffect(() => {
    const loadOptions = async () => {
      try {
        const { data: response } = await getCloseReasons()

        if (response.success && response.data) {
          setOptions(response.data)
        }
      } catch {
        setOptions([])
      }
    }

    loadOptions()
  }, [])

  const handleChange = (selectedData: unknown) => {
    const values = ((selectedData as readonly SelectOptionString[] | null) ?? []).map(
      (item) => item.value
    )

    changeSelect({ value: values, type: selectType })
  }

  return (
    <AppSelect
      isMulti
      value={options.filter((option) => (value ?? []).includes(option.value))}
      onChange={handleChange}
      options={options}
      placeholder={'Без сортировки по причине закрытия'}
      isClearable
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
    />
  )
}

export default ReportCloseReasonFilter
